const ITEM_INTERNAL_KEYS = ['_cellProps', '_props', '_selectable', '_selected'];

export { ITEM_INTERNAL_KEYS };
//# sourceMappingURL=consts.js.map
